import { UpdateCataloguePayload } from 'types/masterData'
import Api from './axiosInstance'
import { API_MASTER_DATA } from 'utils/constants'

type FetchMasterDataParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

const fetchMasterDataDetails = ({
  limit,
  page,
  search,
  filters,
}: FetchMasterDataParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_MASTER_DATA.MASTER_DATA}?${params}`,
  })
}

const fetchMasterDataById = (id: string) => {
  return Api.get({
    url: `${API_MASTER_DATA.MASTER_DATA}/${id}`,
  })
}

const updateMasterData = (id: string, data: UpdateCataloguePayload) => {
  return Api.patch({
    url: `${API_MASTER_DATA.MASTER_DATA}/${id}`,
    data: data,
  })
}

const dowloadMasterData = ({ filters }: { filters: Record<string, any> }) => {
  const params = new URLSearchParams(filters)
  return Api.get({
    url: `${API_MASTER_DATA.MASTER_DATA_EXPORT}?${params}`,
  })
}

// To Upload a Master data file in server and update master data
const importMasterData = async (data: any) => {
  return Api.post({
    url: API_MASTER_DATA.MASTER_DATA_IMPORT,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export {
  fetchMasterDataDetails,
  updateMasterData,
  fetchMasterDataById,
  dowloadMasterData,
  importMasterData,
}
